var _defs, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 640,
    height: 480,
    rx: 40,
    ry: 40
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shine",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.08
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    rx: 40,
    ry: 40,
    fill: "#cfcfcf",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-clip)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 480,
    fill: "#ff0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 0,
    width: 480,
    height: 160,
    fill: "#00732f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 480,
    height: 160,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 480,
    height: 160,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 640,
    height: 480,
    fill: "url(#shine)",
    style: {
      mixBlendMode: "soft-light"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/UAE.36c1bb3c88aaa3e4ebf9be3cca6a5c96.svg";
export { ForwardRef as ReactComponent };